/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RejectJobApplicationCommandDto interface.
 */
export function instanceOfRejectJobApplicationCommandDto(value) {
    if (!('jobApplicationId' in value) || value['jobApplicationId'] === undefined)
        return false;
    if (!('excludeApplicantFor12Months' in value) || value['excludeApplicantFor12Months'] === undefined)
        return false;
    return true;
}
export function RejectJobApplicationCommandDtoFromJSON(json) {
    return RejectJobApplicationCommandDtoFromJSONTyped(json, false);
}
export function RejectJobApplicationCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'jobApplicationId': json['jobApplicationId'],
        'rejectionReasonId': json['rejectionReasonId'] == null ? undefined : json['rejectionReasonId'],
        'rejectionReasonCustom': json['rejectionReasonCustom'] == null ? undefined : json['rejectionReasonCustom'],
        'excludeApplicantFor12Months': json['excludeApplicantFor12Months'],
    };
}
export function RejectJobApplicationCommandDtoToJSON(json) {
    return RejectJobApplicationCommandDtoToJSONTyped(json, false);
}
export function RejectJobApplicationCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'jobApplicationId': value['jobApplicationId'],
        'rejectionReasonId': value['rejectionReasonId'],
        'rejectionReasonCustom': value['rejectionReasonCustom'],
        'excludeApplicantFor12Months': value['excludeApplicantFor12Months'],
    };
}
